export default __webpack_public_path__ + "static/medicaid-9018836e3cb4bc93dab1c67a88c9fcdd.svg";